import { render, staticRenderFns } from "./BlockedPage.vue?vue&type=template&id=a1bbb3ea&scoped=true"
import script from "./BlockedPage.vue?vue&type=script&lang=js"
export * from "./BlockedPage.vue?vue&type=script&lang=js"
import style0 from "./BlockedPage.vue?vue&type=style&index=0&id=a1bbb3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1bbb3ea",
  null
  
)

export default component.exports